module.exports = __webpack_public_path__ + "media/images/knockout__winnerDeco@3x-be3da8127e5dc4a8c39107d9ef3f9ad6.png";